import React from 'react';

type Props = {};

// Divider component
const Divider: React.FC<Props> = () => {
    return (
        <div data-testid="divider" className="w-11/12 mx-auto h-0.5 bg-slate-400 rounded-md"></div>
    );
}

export default Divider;
